import React, { useEffect, useRef, useState } from "react";
import { Container, Card, Button, Alert, Table, Row, Col } from 'react-bootstrap'; // Importing react-bootstrap components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from "xlsx"; 
import $ from 'jquery';
import { useNavigate } from 'react-router-dom';
import Header from "../Header";

const AllWorkDoc = () => {
  const tableRef = useRef(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const id = localStorage.getItem('userId');
  const navigate = useNavigate();
  

  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://apiaksharaconnect.aksharafinalytics.in/getallfiles`
        );
        if (!response.ok) throw new Error("Network response was not ok");

        const result = await response.json();
        setData(result.data || []);
        console.log(result);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleMultipleDownloads = (filePaths) => {
    filePaths.forEach((filePath) => {
      // Create an anchor tag for each file and trigger a click to start downloading
      const link = document.createElement('a');
      link.href = filePath;
      link.download = filePath.split('/').pop(); // Set file name as the last part of the URL
      link.target = '_blank'; // Open in new tab
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  // Initialize DataTable
  useEffect(() => {
    if (tableRef.current && data.length > 0) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true, // Reinitialize on data change
        paging: true, // Enable pagination
        pageLength: 10, // Default number of rows per page
        lengthMenu: [10, 25, 50, 100], // Options for rows per page
        columnDefs: [
          { targets: 0, responsivePriority: 1 }, // Always visible
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
        ],
      });

      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [data]);

  // Export to Excel
  const exportToExcel = () => {
    if (data.length === 0) {
      alert("No data to export!");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "data");
    XLSX.writeFile(wb, "data_List.xlsx");
  };

  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <>
      <Header />
      <Container fluid className="mt-4">
        <Card className="shadow">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h4>Worked Documents  </h4>
            <Button variant="success" onClick={exportToExcel}>
              Export to Excel
            </Button>
          </Card.Header>
          <Card.Body>
            {error && <Alert variant="danger">{error}</Alert>}

            {/* Responsive Table */}
            <div className="table-responsive">
            <Table ref={tableRef} striped bordered hover responsive>
      <thead>
        <tr>
          <th>S.no</th>
          <th>User</th>
          <th>Documents</th>
          <th>Remarks</th>
          <th>Date/Time</th>
        </tr>
      </thead>
      <tbody>
        {data?.length > 0 ? (
          data.map((item, index) => {
            // Split the file_path string into individual file paths and prepend the base URL
            const filePaths = item.file_path.split(',').map(filePath => 
              `https://apiaksharaconnect.aksharafinalytics.in/${filePath.trim()}`
            );

            return (
              <tr key={item.id}>
                <td>{index + 1}</td>  
                <td className="text-primary">{item.Name || 'N/A'}</td>                   
                <td>
                  {filePaths.length > 0 ? (
                    <>
                      <Button variant="warning" className="ms-2 p-1 m-1" onClick={() => handleMultipleDownloads(filePaths)}>
                        <FontAwesomeIcon icon={faDownload} /> Download
                      </Button>                      
                    </>
                  ) : (
                    <span>No file available</span>
                  )}
                </td>
                <td>{item.remarks || 'N/A'}</td> 
                <td>{item.upload_at || 'N/A'}</td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="5" className="text-center">
              No data available
            </td>
          </tr>
        )}
      </tbody>
    </Table>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default AllWorkDoc;
